export const FLOWERING_PHASES = ['flowering'] as const;

export type MaintenanceParcellingContext = {
	floweringMonths: number[];
};

type ParcelMonth = {
	month?: number;
	phase?: string;
};

export const parseMonthNumber = (value?: string | number | null): number | null => {
	if (value == null || value === '') return null;
	if (typeof value === 'number') {
		return Number.isInteger(value) && value >= 1 && value <= 12 ? value : null;
	}
	const normalized = String(value).replace(/\//g, '-');
	if (/^\d{4}-\d{2}/.test(normalized)) {
		const month = Number(normalized.slice(5, 7));
		return month >= 1 && month <= 12 ? month : null;
	}
	const month = Number(normalized);
	return Number.isInteger(month) && month >= 1 && month <= 12 ? month : null;
};

export const getParcellingMonthsByPhase = (
	parcels: ParcelMonth[] | undefined,
	phases: readonly string[]
) => {
	const months = new Set<number>();
	for (const parcel of parcels ?? []) {
		if (!phases.includes(parcel.phase ?? '')) continue;
		const month = parseMonthNumber(parcel.month);
		if (month != null) months.add(month);
	}
	return [...months].sort((a, b) => a - b);
};

export const validateFixedParcellingFlowering = (
	floweringMonth: string,
	floweringMonths: number[]
): Record<string, string> => {
	const floweringNumber = parseMonthNumber(floweringMonth);
	if (floweringMonths.length > 0 && (floweringNumber == null || !floweringMonths.includes(floweringNumber))) {
		return { floweringMonth: 'O esquema de parcelamento selecionado não possui florada neste mês.' };
	}
	return {};
};
